export default __webpack_public_path__ + "static/media/burger.de492d34.svg";